import React from "react";
import { REPORT_TABS } from "../constants/reportTabs";

/**
 * أزرار تابات التقارير (برمجة / تصميم / أخرى / التقرير الشهري ...)
 * كل تاب بيتعرض بس لو فيه بيانات جاية من الباك.
 */
const ReportsList = ({ reports, activeReportTab, setActiveReportTab }) => {
  const availableTabs = REPORT_TABS.filter(
    (t) => reports?.[t.key]?.length > 0,
  );

  if (!availableTabs.length) {
    return <p className="empty-service">لا توجد تقارير متاحة حالياً</p>;
  }

  return (
    <>
      {availableTabs.map((t) => (
        <button
          key={t.key}
          className={`sidebar-btn ${
            activeReportTab === t.key ? "active" : ""
          }`}
          onClick={() => setActiveReportTab(t.key)}
        >
          {t.label}
        </button>
      ))}
    </>
  );
};

export default ReportsList;
